export const ZIP_SHOULD_BE_VALID = 'pdp.main.error.enter_valid_zip';
export const ENTER_VALID_ZIP = 'pdp.pas.error.enter_valid_zip';
